import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';
import { memo } from 'react';
import { twMerge } from 'tailwind-merge';

import { isPromoniverWordOnOfferTitle } from 'lib/offer';

import Instructions from './Instructions';
import UserInstructions from './UserInstructions';

const Faq = dynamic(() => import('./Faq'));

const AdditionalInfos = ({
  className,
  offerFaq,
  offerInstructions,
  offerTitle = '',
  offerUserDescription = null,
}) => {
  if (!offerInstructions && offerFaq.length === 0) {
    return null;
  }

  return (
    <section className={twMerge('flex-col gap-y-4 lg:mr-60', className)}>
      {offerInstructions && (
        <Instructions
          allowTextCopy={!isPromoniverWordOnOfferTitle(offerTitle)}
          instructions={offerInstructions}
        />
      )}
      {offerUserDescription && (
        <UserInstructions instructions={offerUserDescription} />
      )}
      {offerFaq.length > 0 && <Faq offerFaq={offerFaq} />}
    </section>
  );
};

AdditionalInfos.propTypes = {
  className: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  offerFaq: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired,
    })
  ).isRequired,
  offerInstructions: PropTypes.string.isRequired,
  offerUserDescription: PropTypes.string,
  offerTitle: PropTypes.string,
};

export default memo(AdditionalInfos);
